export const GET_LEAGUE_TRANSACTIONS_SUCCESS =
  'Joga/transactions/GET_LEAGUE_TRANSACTIONS_SUCCESS';
export const GET_TEAM_TRADE_REQUESTS =
  'Joga/transactions/GET_TEAM_TRADE_REQUESTS';
export const GET_TEAM_TRADE_REQUESTS_SUCCESS =
  'Joga/transactions/GET_TEAM_TRADE_REQUESTS_SUCCESS';
